import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';

@Component({
  selector: 'app-rate-home2',
  standalone: true,
  imports: [MatCardModule, MatCheckboxModule, MatButtonModule],
  templateUrl: './rate-home2.component.html',
  styleUrl: './rate-home2.component.scss'
})
export class RateHome2Component {

  displayMode: number = 0;

  onDisplayMode(modeNumber: number):void{
    this.displayMode = modeNumber;
  }

}
